import { Component, Inject } from '@angular/core';
import { Budget } from '../../store/reselectors/budget.data';
import { PaymentGridData, BudgetSectionGridData } from '../../helpers/grid-helpers';
import { Dictionary } from '@ngrx/entity';
import { Wrapper } from '../../components/wrapper.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { getGridDataFromSection, scheduleToScheduleGridData } from '../../store/reselectors/budget.reselector.helpers';
import { SnapshotInfo } from 'globals/store/events.data';
import { BigDialogWrapperComponent } from 'src/app/components/wrappers/big-dialog-wrapper.component';
import { CommonModule } from '@angular/common';
import { BudgetTotalsStripComponent } from './budget-totals-strip.component';
import { BudgetSectionComponent } from './budget-section.component';

@Component({
    selector: 'budget-costs-view',
    templateUrl: './costs-view-dialog.html',
    styleUrls: ['./revenue.scss', './costs-view-dialog.scss'],
    standalone: true,
    imports: [BigDialogWrapperComponent, CommonModule, BudgetTotalsStripComponent, BudgetSectionComponent],
})
export class BudgetCostsViewDialogComponent extends Wrapper<BudgetCostsViewDialogComponent>  {

  deleteText = 'Are you sure you want to delete this snapshot of costs?'
  scheduleGridDatas: Dictionary<PaymentGridData[]> = {}
  sectionGridDatas: Dictionary<BudgetSectionGridData[]> = {}
  budget: Budget
  loading = false
  fullBudget: Budget
  readonly api = `${environment.functionsURL}api/app`;

  constructor(public dialogRef: MatDialogRef<BudgetCostsViewDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: BudgetSnapshotDialogData) {
    super()
    
    console.log(data)
    this.downloadSnapshot()
    this.subProp(this.store.select('budget', 'budget'), 'fullBudget')
  } 

  exit() {
    this.dialogRef.close()
  }

  async downloadSnapshot() {
    try {
      this.loading = true
      const url = `${this.api}/load-budget-snapshot` // need to create
      const filePath = `costsSnapshots/${this.data.eventId}/${this.data.info.id}`
      const data = await this.take1(this.http.post(url, { filePath })) as Budget
      if (!data) {
        console.log("NO DATA!")
        return
      }
      this.budget = data
      console.log(data)
      this.budget.costIds.map(id => this.budget.sections[id]).forEach(s => {
        this.sectionGridDatas[s.id] = getGridDataFromSection(s, this.budget.currency)
        this.scheduleGridDatas[s.id] = !s.schedule ? null : scheduleToScheduleGridData(s.schedule, s.schedule.total)
      })
    } catch (error) {
      console.log(error)
    } finally {
      this.loading = false
    }

  }


  async delete() {
    this.fullBudget.costSnapshots = this.fullBudget.costSnapshots.filter(s => s.id !== this.data.info.id)
    await this.budgetService.updateBudget(this.data.eventId, this.fullBudget)
    this.exit()
  }
}

export interface BudgetSnapshotDialogData {
  info: SnapshotInfo
  eventId: string
}